module.exports = __webpack_public_path__ + "static/media/David_tien.6a3f2f43.jpg";